import Swal from 'sweetalert2';

import { IDefaultValue } from '../../../models/DefaultValue';

function useDeleteDefaultValue() {
    const deleteDefaultValue = async (defaultValue: IDefaultValue) => {
        try {
            const queryString = `?sid=${defaultValue.sid}&key=${defaultValue.key}`;

            const response = await fetch('/v1/default-value' + queryString, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('DMS_APPLICATION')}`,
                },
            });

            if (!response.ok) {
                throw await response.json();
            }

            return true;
        } catch (error) {
            const { message } = error as any;
            console.error(message);
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                text: message,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ยืนยัน',
            });
            return;
        }
    };

    return {
        deleteDefaultValue,
    };
}

export default useDeleteDefaultValue;
